var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Show")]),_c('div',[_c('pre',[_vm._v(_vm._s(_vm._f("pretty_json")(_vm.organizational_structure)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }